import { useState } from 'react';

import SpeakForm from "./speak-form";

export default () => {
    const [ checkboxes, setCheckboxes ] = useState([
        [
            {
                text: 'I Accept the privacy policy',
                checked: false
            },
            {
                text: 'Please add me to DMC’s Mailing List',
                checked: false
            }
        ]
    ])

    const toggleCheckBox = (group, index) => {
        const boxes = [ ...checkboxes ];

        boxes[group][index].checked = !boxes[group][index].checked;

        setCheckboxes(boxes);
    }

    return (
        <div className="overlay-speak">
            <h1>SPEAK TO US</h1>
            <div className="overlay__content">
                <div className="overlay-speak__left">
                    <div className="overlay-speak__item-outer">
                        <div className="overlay-speak__item">
                            <h2>Call Us</h2>
                            <p>+44 (0)1226 720700</p>
                        </div>
                        <div className="overlay-speak__item">
                            <h2>Email Us</h2>
                            <p>dmc@barnsley.gov.uk</p>
                        </div>
                    </div>
                    <div className="overlay-speak__item">
                        <h2>Visit Us</h2>
                        <div className="utils__row">
                           <div className="overlay-speak__column">
                                <p>DMC</p>
                                <p>County Way</p>
                                <p>Barnsley</p>
                                <p>S70 2JW</p>
                                <p>England</p>
                           </div>
                           <div className="overlay-speak__column">

                           </div>
                        </div>
                    </div>
                </div>
                <div className="overlay-speak__right">
                    <form>
                        <SpeakForm />
                    </form>
                </div>
            </div>
        </div>
    )
}
